import React, { useState, useEffect, useContext } from 'react';
import { isEmpty } from 'lodash';
import { useLocation } from 'react-router-dom';
import { Card, CardBody, Container } from 'reactstrap';
import SearchContainer from './components/SearchContainer';
import ProvidersTable from './components/ProvidersTable';
import { GlobalContext } from 'globalStates/Store';
import ErrorBoundary from 'components/ErrorBoundary';
import useAxios from 'hooks/useAxios';
import { onExport, getUpdatedFilter } from 'utils/helper';

const initialFilterBySearch = {
  coveredEntityName: '',
};

let initialFilters = {
  currentPage: 1,
  pageSize: 10,
  orderBy: '',
  order: '',
  filters: [],
};

let selectedCoveredEntity = {};

const Providers = () => {

  const location = useLocation();
  let selectedCEId = window.selectedCoveredEntittyId;

  const API = useAxios();
  const [filterBySearch, setFilterBySearch] = useState(initialFilterBySearch);
  const [coveredEntity, setCoveredEntity] = useState([]);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [totalItem, setTotalItem] = useState(0);
  const [researchNeededCount, setResearchNeededCount] = useState(0);
  const [eligibleCount, setEligibleCount] = useState(0);
  const [inEligibleCount, setInEligibleCount] = useState(0);
  const [reFetch, setFetch] = useState(1);
  const [reset, setReset] = useState(false);
  const [colFilter, setColFilter] = useState(true);
  const [isOpenProgram, setOpenProgram] = useState(false);
  const {
    gloabalStates: { claimListTenantID },
  } = useContext(GlobalContext);

  const fetchProvidersList = async (pageDetails = {}, hasColumnFilter) => {
    let filter = { ...pageDetails };
    if (hasColumnFilter) {
      filter.filters = [...initialFilters.filters, ...pageDetails.filters];
      initialFilters.filters = [...initialFilters.filters];
    } else {
      initialFilters = { ...initialFilters, ...pageDetails };
    }
    let { tenantID, coveredEntityID } = selectedCoveredEntity;

    if (!tenantID) return null;
    setLoading(true);
    try {

      let countData = await API.get(`/${tenantID}/CEProvider/geteligibilityforce/${coveredEntityID}`);

      if (countData) {
        let result = countData.data;
        setResearchNeededCount(result.researchNeededCount);
        setEligibleCount(result.eligibleCount);
        setInEligibleCount(result.inEligibleCount);
      }

      const { data } = await API.post(
        `/${tenantID}/CEProvider/all/${coveredEntityID}`,
        filter
      );
      if (data) {
        setData(data.items);
        setTotalItem(data.totalRecords);
      } else {
        setData([]);
        setTotalItem(0);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setData([]);
      setTotalItem(0);
    }
  };

  // const onHandleManualProgram = () => {
  //   setOpenProgram(!isOpenProgram);
  // }

  // const onManualSearch = () => {
  //   setOpenProgram(true);

  // }

  useEffect(() => {
    selectedCoveredEntity = {};
    initialFilters = {
      currentPage: 1,
      pageSize: 10,
      orderBy: '',
      order: '',
      filters: [],
    };
  }, []);

  useEffect(() => {
    handleSearch(filterBySearch);
  }, [reFetch]);

  const handleSearch = async (filters) => {
    const { coveredEntityName, providerID, eligibleFlag } = filters;
    initialFilters = {
      currentPage: initialFilters.currentPage,
      pageSize: initialFilters.pageSize,
      orderBy: initialFilters.orderBy,
      order: initialFilters.order,
      filters: [],
    };

    setColFilter((pre) => !pre);
    setFilterBySearch(filters);
    if (coveredEntityName && !isEmpty(coveredEntityName)) {
      initialFilters.filters = getUpdatedFilter(
        'coveredEntityID',
        parseInt(coveredEntityName),
        initialFilters
      );
    }
    if (providerID) {
      initialFilters.filters = getUpdatedFilter(
        'providerID',
        providerID.id,
        initialFilters
      );
    }

    if (eligibleFlag != "-1") {
      initialFilters.filters = getUpdatedFilter(
        'ISNULL(eligibleFlag,"")',
        eligibleFlag,
        initialFilters
      );
    }

    initialFilters.currentPage = 1;
    await fetchProvidersList(initialFilters);
  };

  const handlePageChange = (pageDetails, hasFilter) => {
    if (hasFilter) {
      fetchProvidersList(pageDetails, true);
    } else {
      fetchProvidersList(pageDetails);
    }
  };

  const handleReset = () => {
    setData([]);
    setReset((pre) => !pre);
    initialFilters = {
      currentPage: 1,
      pageSize: 10,
      orderBy: '',
      order: '',
      filters: [],
    };
    setTotalItem(0);
    selectedCoveredEntity = {};
  };

  const handleSearchColumnFilters = async (columnFilters) => {
    await fetchProvidersList(columnFilters, true);
  };

  const fetchAgain = (id) => {
    setFetch(id);
  };

  const handleExport = () => {
    const { tenantID, coveredEntityID } = selectedCoveredEntity;
    const { access_token } =
      JSON.parse(sessionStorage.getItem('pharmaforce')) || {};
    const action = `${process.env.REACT_APP_ENDPOINT}/${process.env.REACT_APP_ENDPOINT_POSTFIX}/${tenantID}/CEProvider/ExportAll/${coveredEntityID}?access_token=${access_token}`;
    onExport(action, initialFilters);
  };

  const handleUpdateEntity = (entity) => {
    selectedCoveredEntity = entity;
  };

  const refetch = (hasReset) => {
    if (hasReset) {
      initialFilters = {
        ...initialFilters,
        currentPage: 1,
        order: '',
        orderBy: '',
      };
    }
    fetchProvidersList(initialFilters);
  };

  return (
    <div>
      <Container fluid className='my-3'>
        <Card className='border-0 shadow-top'>
          <CardBody className='section-devider-border'>
            <ErrorBoundary>
              <SearchContainer
                filterBySearch={filterBySearch}
                onSearch={handleSearch}
                coveredEntity={coveredEntity}
                onReset={handleReset}
                providerFilters={[]}
                handleUpdateEntity={handleUpdateEntity}
                selectedCEId={selectedCEId}
              // onManualSearch={onManualSearch}
              />
            </ErrorBoundary>
          </CardBody>
          <CardBody className='pt-0'>
            <ErrorBoundary>
              <ProvidersTable
                data={data}
                loading={loading}
                totalSize={totalItem}
                onPageChange={handlePageChange}
                selectedCoveredEntity={claimListTenantID}
                apiFilter={initialFilters}
                formReset={reset}
                onSearchColumnFilters={handleSearchColumnFilters}
                setColFilterFalse={colFilter}
                fetchAgain={fetchAgain}
                onExport={handleExport}
                setLoading={setLoading}
                refetch={refetch}
                coveredEntityTenantID={selectedCoveredEntity.tenantID}
                researchNeededCount={researchNeededCount}
                eligibleCount={eligibleCount}
                inEligibleCount={inEligibleCount}
              />
            </ErrorBoundary>
          </CardBody>
        </Card>
      </Container>
      {/* <Drawer
        direction='end'
        title='Auto-Approve Provider & Patient Combinations'
        isOpen={isOpenProgram}
        toggle={onHandleManualProgram}
        size="lg"
      >
        <PatientProviderMap
          //  hasEditable={true}
          onClose={onHandleManualProgram}
          selectedCoveredEntity={selectedCoveredEntity}
        />
      </Drawer> */}
    </div>
  );
};

export default Providers;
